import React from 'react'
import { AllTransactionList } from './list/page'

export const AllTransactionPage = () => <AllTransactionList />
